import { useCallback } from 'react';
import useAuthenticatedWebsocket from './useAuthenticatedWebSocket';

export default function useGetChats() {
  const { sendJsonMessage } = useAuthenticatedWebsocket();

  const getChats = useCallback(() => sendJsonMessage({
    action: 'get_chat_brief',
  }), [sendJsonMessage]);

  return getChats;
}
